import { useEffect, useState } from "react";
import { useMountedState, useMedia } from "react-use";

const useResponsive = () => {
   const [isReady, setIsReady] = useState(false);
   const isMounted = useMountedState();

   const desktop = useMedia("(min-width: 1025)");
   const tablet = useMedia("(min-width: 768) and (max-width: 1024)");
   const mobile = useMedia("(max-width: 767)");

   const isBreakpointReady = isReady && (desktop || tablet || mobile);

   useEffect(() => {
      if (isMounted()) {
         setIsReady(true);
      }
   }, [isMounted]);

   return {
      mobile,
      tablet,
      desktop,
      isBreakpointReady
   };
};

export default useResponsive;
